import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
	faCartShopping,
	faChartLineUp,
	faCreditCard,
	faReceipt,
	faTruckFast,
} from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@/components/ui/Icon";

export type FloatCardIconKind = "order" | "sales" | "shipping" | "payments" | "cart";

const ICONS: Record<FloatCardIconKind, IconDefinition> = {
	order: faReceipt,
	sales: faChartLineUp,
	shipping: faTruckFast,
	payments: faCreditCard,
	cart: faCartShopping,
};

interface FloatCardIconSvgProps {
	kind: FloatCardIconKind;
	className?: string;
}

function FloatCardIconSvg(prop: FloatCardIconSvgProps) {
	const { kind, className } = prop;
	return <Icon icon={ICONS[kind]} className={className} />;
}

export default FloatCardIconSvg;
